module.exports = __webpack_public_path__ + "static/img/model3-3.df4e6ef4.jpg";